module.exports = __webpack_public_path__ + "img/3-francais.69c799c1.svg";